// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kbArticleSurvey__loaderContainer___3KSco{display:flex;margin-bottom:10px}.kbArticleSurvey__separatorWrap___3Oa8Q{display:flex;justify-content:space-around;align-items:center;width:2rem;margin:1.5rem auto}.kbArticleSurvey__separator___2aZme{width:4px;height:4px;background-color:#54a0db;border-radius:50%}.kbArticleSurvey__confirmationMessage___2TNS3{color:var(--header-font-secondary-color);margin:5px 0 5px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "calc(100% - 30px)",
	"widgetFrameMaxHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"loaderContainer": "kbArticleSurvey__loaderContainer___3KSco",
	"separatorWrap": "kbArticleSurvey__separatorWrap___3Oa8Q",
	"separator": "kbArticleSurvey__separator___2aZme",
	"confirmationMessage": "kbArticleSurvey__confirmationMessage___2TNS3"
};
export default ___CSS_LOADER_EXPORT___;
